import Boom from 'boom'

import makeApi from '../client/api'

export const buyRawCreditConsult = async ({ token, creditcardId, consultedCpf }) => {
  const { api } = makeApi({ token })

  const { ok, data } = await api.post('/credit/raw-consult/buy', {
    creditcard_id: creditcardId,
    consulted_cpf: consultedCpf,
  })

  if (!ok) {
    console.log(data)
    throw Boom.forbidden()
  }

  return { data }
}

export const getRawCreditConsult = async (cpf, token) => {
  const { api } = makeApi({ token })
  const { ok, data } = await api.get(`/credit/raw-consult/${cpf}`)

  if (!ok) {
    throw Boom.forbidden()
  }

  return { data }
}

export const createInsuranceReview = async ({ token, data }) => {
  const api = makeApi({ token })

  const response = await api.create('/insurances', { data })

  return response
}

export const getInsuranceReview = async ({ token, id }) => {
  const api = makeApi({ token })
  console.log('id', id)
  const response = await api.getOne('/insurances/', { id })

  return response
}
